<template>
    <div class="card" data-testid="reception-visits">
        <div class="card-header">
            <div class="row">
                <div class="col-md-4">
                    <b>Návštěvy</b> {{ print_date }}
                </div>
                <div class="col-md-7">
                    <div class="input-group">
                        <span class="input-group-btn">
                            <button @click="selectToday()" class="btn btn-primary btn-sm" data-testid="reception-visits-today">dnes</button>
                            <button @click="selectTomorrow()" class="btn btn-secondary btn-sm" data-testid="reception-visits-tomorrow">zítra</button>
                        </span>
                        <datepicker v-model="selectedDate" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="validFrom"></datepicker>
                    </div>
                </div>
                <div class="col-md-1 text-right">
                    <button @click="getDoctorsDayVisits()" class="btn btn-secondary btn-sm"><i class="fa fa-refresh"></i></button>
                </div>
            </div>
        </div>
        <div class="card-header">
            <div class="row">
                <div class="col-md-8 text-left">
                    <select v-model="plannedFor" class="mr-sm-2" aria-describedby="doctorHelp" id="doctor" placeholder="vybrat doktora" v-if="doctors.length > 0" data-testid="reception-visits-doctor">
                        <option value="">všichni doktoři</option>
                        <option v-for="row in doctors" v-bind:value="row.id">{{ row.fullname }}</option>
                    </select>

                    <button class="btn btn-sm btn-outline-danger" value="scheduled" v-if="selectedStates.indexOf('scheduled') < 0" @click="selectedStates.push('scheduled')" data-testid="reception-visits-filter-scheduled">plánovaní</button>
                    <button class="btn btn-sm btn-success" value="scheduled" v-else="" @click="selectedStates.splice(selectedStates.indexOf('scheduled'), 1)" data-testid="reception-visits-filter-scheduled">plánovaní</button>

                    <button class="btn btn-sm btn-outline-danger" value="arrived" v-if="selectedStates.indexOf('arrived') < 0" @click="selectedStates.push('arrived')">v čekárně</button>
                    <button class="btn btn-sm btn-success" value="arrived" v-else="" @click="selectedStates.splice(selectedStates.indexOf('arrived'), 1)">v čekárně</button>

                    <button class="btn btn-sm btn-outline-danger" value="completed" v-if="selectedStates.indexOf('elaborated') < 0" @click="selectedStates.push('elaborated')">rozpracovaní</button>
                    <button class="btn btn-sm btn-success" value="completed" v-else="" @click="selectedStates.splice(selectedStates.indexOf('elaborated'), 1)">rozpracovaní</button>

                    <button class="btn btn-sm btn-outline-danger" value="completed" v-if="selectedStates.indexOf('completed') < 0" @click="selectedStates.push('completed')">splněno</button>
                    <button class="btn btn-sm btn-success" value="completed" v-else="" @click="selectedStates.splice(selectedStates.indexOf('completed'), 1)">splněno</button>

                    <button class="btn btn-sm btn-outline-danger" value="canceled" v-if="selectedStates.indexOf('failed') < 0" @click="selectedStates.push('failed') + selectedStates.push('excused')">nepřišel</button>
                    <button class="btn btn-sm btn-success" value="canceled" v-else="" @click="selectedStates.splice(selectedStates.indexOf('failed'), 1) + selectedStates.splice(selectedStates.indexOf('excused'), 1)">nepřišel</button>

                    <button class="btn btn-sm btn-outline-danger" value="canceled" v-if="selectedStates.indexOf('canceled') < 0" @click="selectedStates.push('canceled')">zrušeno</button>
                    <button class="btn btn-sm btn-success" value="canceled" v-else="" @click="selectedStates.splice(selectedStates.indexOf('canceled'), 1)">zrušeno</button>
                </div>
                <div class="col-md-4 text-right">
                    <template v-if="showRemainingVisitsToo">
                        <button class="btn btn-sm btn-outline-danger" @click="showHideRemainingVisits">filtrovat dle důvodu</button>
                    </template>
                    <template v-else="">
                        <multiselect id="medics" v-model="selectedVisitPurposes" props="options" :options="visitPurposes" track-by="id" label="purpose" placeholder="důvod návštěvy" :multiple="true" :limit="1" :limit-text="limitText" :option-height="104" open-direction="down" :show-labels="false" TagPlaceholder="" selectLabel="" @input="selectVisitPurposesId"></multiselect>
                    </template>
                </div>
            </div>
        </div>
        <template v-if="visits.length > 0">
            <div class="card-body pl-0 pr-0" v-if="filteredVisits.length > 0">
                <table class="table">
                    <tbody>
                    <template v-for="(visit, index) in filteredVisits" class="card-text">
                        <tr :data-testid="'reception-visit-' + visit.id">
                            <td rowspan="2"
                                class="align-middle"
                                :style="{ borderLeft: (visit.visit_purpose.color !== '' ? '5px solid #' + visit.visit_purpose.color : '5px solid transparent') }">
                                <visit-change-state v-on:update="getDoctorsDayVisits" :actual-state="visit.state" :selected-doctor-id="visit.planned_for.id" :visit-id="visit.id"></visit-change-state>
                            </td>
                            <td class="align-middle">
                                <template v-if="visit.hasData">
                                    <button @click="showHideVisitDetail(index)" class="btn btn-sm btn_extra_small btn-primary"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
                                </template>
                                {{ visit.date }} od {{visit.timeFrom}} do {{visit.timeTo}}  ({{ visit.duration * 5 | minutesToCsTime }})
                            </td>
                            <td>

                            </td>
                            <td colspan="2" class="align-middle pr-2">
                                    <b>{{ visit.visit_purpose.purpose }}</b>
                                <template v-if="editingVisitId === visit.id "><label for="note">poznámka: </label>
                                    <form class="form-inline" @submit.prevent="putVisit(visit)">
                                        <input v-model="editingVisit.note" type="text" class="form-control ml-sm-1 col-sm-10 mr-sm-2" aria-describedby="noteHelp" id="note" :data-testid="'reception-visit-note-' + visit.id">
                                        <button v-if="!waitForSave" type="submit" class="btn btn-primary" :data-testid="'reception-visit-save-' + visit.id">Uložit</button>
                                        <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                    </form>
                                </template>
                                <template v-else=""><button @click="editVisit(visit.note, visit.id)" class="btn btn-sm btn-link text-secondary" :data-testid="'reception-visit-edit-' + visit.id"><i class="fa fa-pencil" aria-hidden="true"></i></button><i>poznámka: {{ visit.note }}</i></template>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" class="no-top-border">
                                <router-link class="text-secondary" :to="{ name: 'ShowClient', params: { clientid: visit.client.id }}"><i class="fa fa-address-card-o" aria-hidden="true"></i></router-link> <b>{{ visit.client.full_name }}</b> - <span v-if="visit.client.insurance_number">ČP: <b>{{ visit.client.insurance_number }}</b></span> <span v-else="">RČ: <b>{{ visit.client.p_i_n }}</b></span>
                                <span class="badge badge-warning" v-if="visit.client.health_insurance && visit.client.health_insurance.code === '---'">SAMOPLÁTCE</span>
                                <span class="badge badge-secondary" v-else-if="visit.client.health_insurance">{{ visit.client.health_insurance.code }}</span>
                                <span class="badge badge-danger" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> chybí zdrav. pojišťovna</span>
                                <template v-if="visit.client.membership">
                                    <span class="badge"
                                          :class="[visit.client.membership.name === 'VIP' ? 'badge-danger' : (visit.client.membership.name === 'PREVENCE PLUS' ? 'badge-success' : ''), 'badge-primary']"
                                          v-if="membershipExpiresSoon(visit.client.membership) && (visit.client.membership.has_next_membership === false)" v-tooltip="{
                                      content: 'končí již: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
                                      placement: 'bottom-center',
                                      classes: ['danger']}">
                                        <i class="fa fa-warning text-danger" aria-hidden="true"></i>
                                        <i class="fa fa-dollar text-danger" v-if="visit.client.membership.paid === false"></i>
                                        {{ visit.client.membership.name }}
                                      <template v-if="visit.client.membership.name === 'VIP'">
                                        <i class="fa fa-star text-white"></i>
                                        <i class="fa fa-star text-white"></i>
                                        <i class="fa fa-star text-white"></i>
                                      </template>
                                    </span>
                                    <span class="badge" v-else=""
                                          :class="[visit.client.membership.name === 'VIP' ? 'badge-danger' : (visit.client.membership.name === 'PREVENCE PLUS' ? 'badge-success' : ''), 'badge-primary']"
                                          v-tooltip="{
                                      content: 'platný do: <b>' + visit.client.membership.valid_to + '</b>' + (visit.client.membership.has_next_membership === true ? '<br> navazuje další program' : '') + (visit.client.membership.paid === false ? '<br> <span class=\'text-danger\'>klient nezaplatil</span>' : ''),
                                      placement: 'bottom-center',
                                      classes: ['info']}">
                                        <i class="fa fa-dollar text-danger" v-if="visit.client.membership.paid === false"></i>
                                        {{ visit.client.membership.name }}
                                      <template v-if="visit.client.membership.name === 'VIP'">
                                        <i class="fa fa-star text-white"></i>
                                        <i class="fa fa-star text-white"></i>
                                        <i class="fa fa-star text-white"></i>
                                      </template>
                                    </span>
                                </template>
                                <span class="badge badge-secondary" v-else-if="visit.client.last_membership" v-tooltip="{
                                      content: 'skončil: <b>' + visit.client.last_membership.valid_to,
                                      placement: 'bottom-center',
                                      classes: ['secondary']}"><i class="fa fa-warning" aria-hidden="true"></i> poslední: {{ visit.client.last_membership.name }}</span>
                                <span class="badge badge-warning" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> nemá program</span>

                              <template v-if="visit.client.gdpr_consent">
                                <span class="badge badge-success" v-if="visit.client.gdpr_consent.agreed" v-tooltip="{
                                            content: 'souhlasil dne: <b>' + visit.client.gdpr_consent.recorded_on + '</b>',
                                            placement: 'bottom-center',
                                            classes: ['info']}">
                                    GDPR
                                  <i class="fa fa-check text-white" aria-hidden="true"></i>
                                </span>
                                                    <span class="badge badge-secondary" v-else v-tooltip="{
                                            content: 'NEsouhlasil dne: <b>' + visit.client.gdpr_consent.recorded_on + '</b>',
                                            placement: 'bottom-center',
                                            classes: ['secondary']}">
                                    GDPR
                                  <i class="fa fa-times text-white" aria-hidden="true"></i>
                                </span>
                              </template>
                                                <span class="badge badge-danger" v-else v-tooltip="{
                                          content: 'nemá vyplněné GDPR',
                                          placement: 'bottom-center',
                                          classes: ['danger']}">
                                  bez GDPR
                                <i class="fa fa-exclamation-triangle text-white" aria-hidden="true"></i>
                            </span>

                                <span class="badge badge-warning" v-if="visit.client.missing_data"><i class="fa fa-danger" aria-hidden="true"></i> chybějící údaje</span>
                                <span class="badge badge-warning" v-if="visit.client.missing_contact"><i class="fa fa-danger" aria-hidden="true"></i> chybějící kontakty</span>
                            </td>
                            <td colspan="1" class="border-top-0 text-right pr-2">
                                {{ visit.planned_for.fullname }}
                                <visit-change-doctor v-on:update="getDoctorsDayVisits" :doctors="doctors" :selected-doctor-id="visit.planned_for.id" :visit-id="visit.id"></visit-change-doctor>
                                <i v-if="visit.planned_by && visit.planned_at" class="text-info fa fa-lg fa-info-circle" aria-hidden="true" v-tooltip="{
                                      content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne ' + visit.planned_at,
                                      placement: 'bottom-center',
                                      classes: ['info']}"></i>
                            </td>
                        </tr>
                        <tr v-if="showedVisitDetail.indexOf(index) > -1">
                            <td class="border-top-0">

                            </td>
                            <td class="" colspan="2">
                                <div class="row m-0" v-if="visit.presenting_complaint">
                                    <h6>{{ visit.presenting_complaint.anamnesis_type.name }}</h6>
                                    <div v-html="visit.presenting_complaint.text"></div>
                                </div>
                                <div class="" v-else-if="visit.medical_report">
                                    <h6>Výsledná zpráva</h6>
                                    <div v-html="visit.medical_report.text"></div>
                                </div>
                            </td>
                            <td class="pr-2" colspan="2">
                                <div class="">
                                    <h6>Diagnózy a výkony</h6>
                                    <div>
                                        <table class="table">
                                            <tbody>
                                            <template v-for="diagnose in visit.diagnosis">
                                                <tr>
                                                    <td>{{ diagnose.disease.code }}</td>
                                                    <td>{{ diagnose.disease.name_cs }}</td>
                                                </tr>
                                                <template v-if="diagnose.actions.length > 0">
                                                    <template v-for="action in diagnose.actions">
                                                        <tr>
                                                            <td></td>
                                                            <td>
                                                                {{ action.operation.code }} - {{ action.operation.name }}
                                                            </td>
                                                        </tr>
                                                        <template v-if="action.zulp.length > 0">
                                                            <tr v-for="zulp in action.zulp">
                                                                <td></td>
                                                                <td>
                                                                    &nbsp;&nbsp;&nbsp;zulp: {{ zulp.amount }}x {{ zulp.medicine.label }}
                                                                </td>
                                                            </tr>
                                                        </template>
                                                        <template v-if="action.zum.length > 0">
                                                            <tr v-for="zum in action.zum">
                                                                <td></td>
                                                                <td>
                                                                    &nbsp;&nbsp;&nbsp;zum: {{ zum.amount }}x {{ zum.material.label }}
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else="">
                                                    <tr>
                                                        <td></td>
                                                        <td>
                                                            <i>(diagnóza nemá přidělené výkony)</i>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="">
                                    <h6>Recepty</h6>
                                    <div>
                                        <template v-if="visit.prescriptions.length > 0">
                                            <table class="table">
                                                <tbody>
                                                <template v-for="p in visit.prescriptions">
                                                    <template v-for="(m, index) in p.medicaments" class="card-text">
                                                        <tr class="row m-0" v-if="p.status === 'PREPARED' || p.type === 'printed'">
                                                            <td class="text-center col-md-1" v-if="index === 0">
                                                                <span v-if="p.type === 'printed'">
                                                                    <i class="fa fa-print" aria-hidden="true"></i>
                                                                </span>
                                                                <span v-if="p.type === 'electronic'" class="font-weight-bold">
                                                                    <span class="green">E</span>R.
                                                                </span>
                                                            </td>
                                                            <td v-else="" class="col-md-1 empty_cell"></td>
                                                            <td class="align-middle col-md-7">
                                                              {{ m.medicine ? m.medicine.label : '' }}
                                                              {{ m.individual_medicine ? m.individual_medicine.name : '' }}
                                                            </td>
                                                            <td class="align-middle col-md-1">
                                                                {{ m.amount }}
                                                            </td>
                                                            <td class="align-middle col-md-2">
                                                                {{ m.dosage }}
                                                            </td>
                                                            <td class="align-middle col-md-1" v-if="index === 0">
                                                                <i class="fa fa-mobile-phone" aria-hidden="true" v-if="p.patient_notification_type === 'SMS'"></i>
                                                                <i class="fa fa-envelope-o" aria-hidden="true" v-else-if="p.patient_notification_type === 'EMAIL'"></i>
                                                                <i class="fa fa-ban text-danger" aria-hidden="true" v-else=""></i>
                                                            </td>
                                                            <td v-else="" class="col-md-1 empty_cell"></td>
                                                        </tr>
                                                    </template>
                                                </template>
                                                </tbody>
                                            </table>
                                        </template>
                                        <template v-else="">
                                            <i>žádný lék nepředepsán</i>
                                        </template>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <div class="card-body" v-if="remainingVisits.length > 0">
                <div class="card-text">... a {{ remainingVisits.length }} {{ remainingVisits.length > 4 ? 'vyfiltrovaných' : 'vyfiltrovaný' }}
                    <button class="btn btn-sm btn-outline-danger" @click="showHideRemainingVisits" data-testid="reception-visits-show-filtered">zobrazit také</button>
                </div>
            </div>
        </template>
        <div class="card-body" v-else-if="visitsPending">
            <div class="text-center">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                    (načítám)
            </div>
        </div>
        <div class="card-body" v-else="">
            <div class="text-center">
                <i class="fa fa-frown-o fa-3x"></i><br/>
                (na tento den není nic naplánováno)
            </div>
        </div>
    </div>
</template>

<script>
  import moment from 'moment'
  import VisitChangeDoctor from '../components/VisitChangeDoctor.vue'
  import VisitChangeState from '../components/VisitChangeState.vue'

  import Datepicker from 'vuejs-datepicker'
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        visits_header_title: '',
        showedVisitDetail: [],
        // visits: '',
        selected_date: '',
        get_params: {
          date: ''
        },
        selectedStates: [],
        print_date: '',
        plannedFor: null,
        doctors: [],
        doctorsPending: false,
        doctorsError: false,
        selectedDoctorId: null,
        showDoctorModal: false,
        selectedDate: '',
        selectedVisitId: null,
        visits: false,
        visitsError: false,
        visitsPending: true,
        visitsDone: false,
        waiting: true,
        editingVisitId: false,
        editingVisit: {},
        waitForSave: false,
        // filetred Visits
        filteredVisits: false,
        remainingVisits: false,
        showRemainingVisitsToo: false,
        // Visit Purposes
        visitPurposes: [],
        visitPurposesPending: false,
        visitPurposeError: false,
        visitPurposesDone: false,
        // filtering
        selectedVisitPurposes: [],
        filteredVisitPurposesId: [1, 2, 3, 4, 5, 8, 9, 10, 15]
      }
    },
    mixins: [apiMixin],
    methods: {
      showHideRemainingVisits () {
        this.showRemainingVisitsToo = !this.showRemainingVisitsToo
        this.visitFiltering()
      },
      visitFiltering () {
        if (this.visits !== false) {
          this.filteredVisits = []
          this.remainingVisits = []
          if (this.showRemainingVisitsToo === true) {
            this.filteredVisits = this.visits
          } else {
            for (let index = 0; index < this.visits.length; ++index) {
              if (this.filteredVisitPurposesId.indexOf(this.visits[index].visit_purpose.id) > -1) {
                this.filteredVisits.push(this.visits[index])
              } else {
                this.remainingVisits.push(this.visits[index])
              }
            }
          }
        }
      },
      editVisit (note, id) {
        this.editingVisitId = id
        this.editingVisit = {
          note: note
        }
      },
      putVisit () {
        this.waitForSave = true
        this.$http.put('visit/' + this.editingVisitId, this.editingVisit, {emulateJSON: true}).then(response => {
          this.waitForSave = false
          this.editingVisitId = false
          this.editingVisit = {}
          this.getDoctorsDayVisits()
        }, response => {
          this.errors = response.data.errors
          this.waitForSave = false
        })
      },
      changeState (visitId, event) {
        this.$http.put('visit/' + visitId + '/change_state', {state: event.target.value}, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.waitForResponse = false
          this.getDoctorsDayVisits()
        }, response => {
          this.errors = response.data.errors
          this.waitForResponse = false
        })
      },
      showHideVisitDetail (index) {
        if (this.showedVisitDetail.indexOf(index) === -1) {
          this.showedVisitDetail.push(index)
        } else {
          this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1)
        }
      },
      getDoctorsDayVisits () {
        this.showedVisitDetail = []
        let getParams = {
          date: moment(this.selected_date).format('DD.MM.YYYY'),
          planned_for: this.plannedFor /* this.$store.state.userId */,
          states: JSON.stringify(this.selectedStates)}
        this.getDayVisits(getParams)
      },
      selectToday () {
        this.selectedDate = moment().toDate()
      },
      selectTomorrow () {
        this.selectedDate = moment().add(1, 'days').toDate()
      },
      setDateAndLoad () {
        switch (this.selected_date.startOf('day').diff(moment().startOf('day'), 'days')) {
          case 0:
            this.print_date = 'Dnes (' + moment(this.selected_date).format('DD.MM.YYYY') + ')'
            break
          case 1:
            this.print_date = 'Zítra (' + moment(this.selected_date).format('DD.MM.YYYY') + ')'
            break
          case -1:
            this.print_date = 'Včera (' + moment(this.selected_date).format('DD.MM.YYYY') + ')'
            break
          default:
            this.print_date = moment(this.selected_date).format('dddd') + ' (' + moment(this.selected_date).format('DD.MM.YYYY') + ')'
        }
        this.getDoctorsDayVisits()
        this.waiting = false
      },
      moment: function (date) {
        return moment(date)
      },
      showModalChangeVisitDoctor (selectedDoctorId) {
        this.selectedDoctorId = selectedDoctorId
        this.showModal('visit-change-doctor')
      },
      showModal (name) {
        // console.log('zobrazuji modal')
        this.$modal.show(name)
      },
      membershipExpiresSoon (membership) {
        if (this.$moment(membership.valid_to, 'DD.MM.YYYY').diff(this.$moment(), 'days') < 31) {
          return true
        } else {
          return false
        }
      },
      limitText (count) {
        if (count > 4) {
          return `a ${count} dalších`
        } else {
          return `a ${count} další`
        }
      },
      selectVisitPurposesId () {
        this.filteredVisitPurposesId = []
        for (let index = 0; index < this.selectedVisitPurposes.length; ++index) {
          this.filteredVisitPurposesId.push(this.selectedVisitPurposes[index].id)
        }
        this.visitFiltering()
      }
    },
    beforeMount () {
      this.getDoctors()
      this.getVisitPurposes()
      moment.locale('cs')
      if (this.$ls.get('home_date')) {
        this.waiting = true
        this.plannedFor = this.$ls.get('home_plannedfor')
        this.selectedStates = JSON.parse(this.$ls.get('home_states'))
        this.selectedDate = moment(this.$ls.get('home_date'), 'DD.MM.YYYY').toDate()
      } else {
        this.selectToday()
        this.$ls.set('home_date', moment().format('DD.MM.YYYY'))
        this.selectedStates = ['scheduled', 'arrived', 'elaborated']
      }
    },
    watch: {
      visitsDone (val) {
        if (val === true) {
          this.visitFiltering()
          this.visitsDone = false
        }
      },
      visitPurposesDone (val) {
        if (val === true) {
          for (let index = 0; index < this.visitPurposes.length; ++index) {
            if (this.filteredVisitPurposesId.indexOf(this.visitPurposes[index].id) > -1) {
              this.selectedVisitPurposes.push(this.visitPurposes[index])
            }
          }
        }
      },
      selectedStates: function (val) {
        this.$ls.set('home_states', JSON.stringify(val))
        if (!this.waiting) {
          this.getDoctorsDayVisits()
        }
      },
      plannedFor: function (val) {
        this.$ls.set('home_plannedfor', val)
        if (!this.waiting) {
          this.getDoctorsDayVisits()
        }
      },
      selectedDate: function (val) {
        this.$ls.set('home_date', moment(val).format('DD.MM.YYYY'))
        this.selected_date = moment(val)
        this.setDateAndLoad()
      }
    },
    components: {
      VisitChangeDoctor,
      VisitChangeState,
      Datepicker
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .btn_extra_small {
        line-height: 1;
        padding: 0.1rem;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

    span.green {
        color: green;
    }

</style>



// WEBPACK FOOTER //
// src/views/HomeReceptionist/components/Visits.vue?103c8c95